<template>
  <div class="modal-full" id="INV_SELECT_MODAL">
    <div class="modal-content-full">
      <div class="row" style="height: 100%">
        <div class="col-3"></div>
        <div class="col-6">
          <div class="centered" style="background-color: whitesmoke; width: 100%; height: 75%">
            <br/>
            <div class="row">
              <div class="col-1"></div>
              <div class="col-8"><b>ВЫБОР ДАННЫХ</b></div>
              <div class="col-3">
                <b @click="close">отмена</b>
              </div>
            </div>
            <br/>

            <div class="row" v-for="(item, index) in items" :key="index" style="vertical-align: middle; margin-top: 5px; margin-bottom: 5px">
              <div class="col-1"></div>
              <div class="col-4">{{item.name}}</div>
              <div class="col-4">{{item.value}}</div>
              <div class="col-2">
                <base-button @click="select(item.id)" :size="'sm'" type="info" fill>Выбрать</base-button>
              </div>
              <div class="col-1"></div>
            </div>
          </div>
        </div>
        <div class="col-3"></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  props:{
    items: [],
    field: {},
    index: 0
  },
  data() {
    return {
      socket: null,
      object: null,
      inSave: false,
      dataReady: false,
      patterns: [],
      fieldsKey: 0
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    select(id) {
      this.$emit("select",{id: id, index : this.index})
    }
  }
}
</script>
<style>
</style>
